import{B as D}from"./chunk-BaseElement-QCmfBlzK.js";import{c as O}from"./chunk-constructorio-kL1h0Ctx.js";import{x as n,T as h}from"./chunk-lit-element-CULRVKo8.js";import{c as y}from"./chunk-repeat-CLr2jifB.js";import{t as j}from"./chunk-custom-element-BhZVzxrc.js";import{n as b}from"./chunk-property-BXqvfTtY.js";import"./chunk-constructorio-DDhIvy8f.js";import"./chunk-_commonjsHelpers-Cpj98o6Y.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-R4cBqjor.js";var L=Object.defineProperty,N=Object.getOwnPropertyDescriptor,g=(t,e,l,s)=>{for(var r=s>1?void 0:s?N(e,l):e,i=t.length-1,a;i>=0;i--)(a=t[i])&&(r=(s?a(e,l,r):a(r))||r);return s&&r&&L(e,l,r),r};let m=class extends D{constructor(){super(...arguments),this.textSort="",this.textFilter="",this.textHideCount="",this.textViewAllCount="",this.textApply="",this.textClearAll="",this.dataResultsGridWithCountOne="",this.dataResultsGridWithCountOther="",this.type="",this.facetsCheckboxVisibleLimit=8,this.currentPage=1,this.resultsPerPage=16,this.resourcesData={},this._constructorResponseID=0}connectedCallback(){super.connectedCallback(),this.fetchAllResources()}async fetchAllResources(){try{const t=await this.getPaginatedResults();if(t){const{results:e,totalPages:l,facets:s,sortOptions:r,totalResults:i}=t;if(!e)return;const a=e.length>0?e.map(d=>{var o,u,f;return{handle:(o=d.data)==null?void 0:o.handle,type:((u=d.data)==null?void 0:u.type)??"",id:((f=d.data)==null?void 0:f.id)??""}}):[];this.resourcesData={sortOptions:r,facets:s,cards:a,paginationIds:Array.from({length:l},(d,o)=>o+1),totalResults:i}}}catch(t){console.error("Error fetching browse results:",t)}}async getPaginatedResults(t=1,e=16,l={},s=""){var r,i,a,d;try{const o=await O.browse({filterName:"type",filterValue:this.type,section:"Articles",resultsPerPage:e,page:t,filters:l,sortBy:s,sortOrder:s.includes("ascending")?"ascending":"descending"},{enabled:!0,expiryMs:12e4}),u=(r=o==null?void 0:o.response)==null?void 0:r.results,f=(i=o==null?void 0:o.response)==null?void 0:i.total_num_results,v=Math.ceil((f??1)/this.resultsPerPage),w=(a=o==null?void 0:o.response)==null?void 0:a.facets,c=(d=o==null?void 0:o.response)==null?void 0:d.sort_options;return{results:u,totalPages:v,currentPage:t,facets:w,sortOptions:c,totalResults:f}}catch(o){return console.error("Constructor.io pagination error:",o),null}}async filterChanged(t,e){var w;if(!t)return;const l=e==null?void 0:e.hasAttribute("target-clear-all-filters");if(e)if(e.id.toLowerCase().includes("mobile")){if(e.getAttribute("type")==="radio"){const c=document.querySelector('select[name="sort_by"]');c&&(c.value=e.value,c.dispatchEvent(new Event("change",{bubbles:!0})))}else{const c=e.id.replace("Mobile","Desktop"),x=document.getElementById(c);x&&(x.checked=e.checked,x.dispatchEvent(new Event("change",{bubbles:!0})))}return}else if(e.tagName.toLowerCase()==="select"){const c=document.querySelector(`[type="radio"][name="sort_by"][value="${e.value}"]`);c.checked=!0}else{const c=document.getElementById(e.id.replace("Desktop","Mobile"));c&&(e.type=="checkbox"?c.checked=e.checked:c.value=e.value)}const s=(w=t.querySelector("#SortOptionsFormDesktop select"))==null?void 0:w.value;let r=1;const i=t.querySelector("[aria-current='page']");i&&!e&&i.textContent&&(r=parseFloat(i.textContent));const a=parseFloat(t.getAttribute("data-pagination-results-per-page")),d=t.querySelector("[target-filters]"),o=new FormData(d),u={};for(const[c,x]of o.entries())u[c]?Array.isArray(u[c])?u[c].push(x):u[c]=[u[c],x]:u[c]=x;const f={};if(!l)for(const[c,x]of Object.entries(u))c!=="sort_by"&&(f[c]=x);this.scrollIntoView();const v=await this.getPaginatedResults(r,a,f,s);if(this._constructorResponseID++,v){const{results:c,totalPages:x,facets:k,sortOptions:P,totalResults:z}=v,C=c&&c.length>0?c.map(p=>{var $,_,S,A,R,M;return($=p.data)!=null&&$.handle&&((_=p.data)!=null&&_.type)&&((S=p.data)!=null&&S.id)?{handle:(A=p.data)==null?void 0:A.handle,type:(R=p.data)==null?void 0:R.type,id:(M=p.data)==null?void 0:M.id}:{}}):[];if(!C)return;const F=(k==null?void 0:k.filter(p=>(p==null?void 0:p.type)==="multiple").map(p=>({...p,opened:Array.isArray(p.options)&&p.options.some($=>$.status!=="")})))??[];console.log("facetsWithOpenedStatus:",F),this.resourcesData={sortOptions:P,cards:C,facets:F,paginationIds:Array.from({length:x},(p,$)=>$+1),totalResults:z},this.scrollIntoView({behavior:"smooth",block:"start"})}}paginateHandleClick(t){var r,i;const e=t.target,l=(i=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:i.querySelectorAll("button:not([data-direction])"),s=parseInt(e==null?void 0:e.textContent);this.currentPage=s,l==null||l.forEach(a=>{var u;const o=parseInt((u=a.querySelector("span"))==null?void 0:u.textContent)==s;a.classList.toggle("border-t-foreground",o),a.classList.toggle("border-t-border",!o),o?(a.setAttribute("aria-current","page"),this.filterChanged(e.closest("search-results-section"))):a.removeAttribute("aria-current")})}paginateArrowClick(t){var r,i,a,d;const e=t.target,l=(i=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:i.querySelector("[aria-current='page']"),s=(d=(a=e.parentElement)==null?void 0:a.parentElement)==null?void 0:d.querySelectorAll("button:not([data-direction])");if(l&&s&&e){const o=Array.from(s).indexOf(l),u=parseFloat(e==null?void 0:e.getAttribute("data-direction"));u>0&&o<s.length-1&&s[o+1].click(),u<0&&o>0&&s[o-1].click()}}applyFilterEvent(t){const e=t.target;this.currentPage=1,this.filterChanged(e.closest("search-results-section"),e)}clearAllFilters(t){t.preventDefault(),this.applyFilterEvent(t)}handleSelectChange(t){this.applyFilterEvent(t)}handleCheckboxChange(t){this.applyFilterEvent(t)}handleize(t){return t.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")}getFacetsHTML(t,e,l){var r;const s=t==null?void 0:t.reduce((i,a)=>{const d=a.type!="range"?a.options.filter(o=>o.status==="selected").length:Object.hasOwn(a.status,"min")&&Object.hasOwn(a.status,"max")&&(a.status.min!=a.min||a.status.max!=a.max)?1:0;return i+d},0);return n`
      <div class="flex h-full w-full flex-col">
        <div
          class="flex-grow${e=="Mobile"?" overflow-auto":h}"
        >
          ${y(t??[],i=>i.name+e+this._constructorResponseID,i=>{var a;return n` ${((a=i.display_name)==null?void 0:a.toLowerCase())!="type"?n` <details
                    class="group/details border-b border-t-border"
                    ?open="${e!="Mobile"||i.opened}"
                  >
                    <summary
                      class='focus-inset group/filter-dropdown md:after:content-[" "] relative flow-root cursor-pointer max-md:px-xs max-md:py-md md:pointer-events-none md:cursor-auto md:pb-xs md:pt-sm md:after:pointer-events-none md:after:absolute md:after:left-0 md:after:top-0 md:after:z-10 md:after:block md:after:h-full md:after:w-full'
                    >
                      <div
                        class="flex w-full items-center justify-between text-sm"
                      >
                        <span
                          class="${window.brand=="NG"?"text-t-foreground-secondary":""} text-heading-6 font-medium capitalize"
                          >${i.display_name}</span
                        >
                        <span class="hidden group-open/details:block">
                          <svg-icon
                            src="icon-minus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                        <span class="block group-open/details:hidden">
                          <svg-icon
                            src="icon-plus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                      </div>
                    </summary>
                    ${n`
                      ${i.type==="multiple"?n`
                            <div
                              class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                            >
                              <ul class="list-unstyled space-y-2xs" role="list">
                                ${y(i.options,d=>d.value,(d,o)=>n` ${d.display_name!=""?n` <li
                                          class=${o>=this.facetsCheckboxVisibleLimit?'group-has-[toggle-button[data-toggled="false"]]/facet:hidden':""}
                                        >
                                          <div
                                            class="group/checkbox inline-flex items-center justify-start gap-x-xs"
                                          >
                                            <label
                                              class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                              for="Filter-filter.p.${this.handleize(d.display_name)}-${e}-${o}"
                                            >
                                              <input
                                                type="checkbox"
                                                class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                                id="Filter-filter.p.${this.handleize(d.display_name)}-${e}-${o}"
                                                value="${d.value}"
                                                name="${i.name}"
                                                aria-labelledby="Filter-filter.p.${this.handleize(d.display_name)}-${e}-${o}_label"
                                                .checked=${d.status!==""}
                                                @change=${this.handleCheckboxChange}
                                              />
                                              <span
                                                class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                              >
                                                <svg-icon
                                                  src="icon-checkbox-tick"
                                                  class="block"
                                                  style="--icon-size: 12px;"
                                                ></svg-icon>
                                              </span>
                                            </label>
                                            <label
                                              class="text-body mt-px cursor-pointer select-none break-all capitalize text-t-foreground group-has-[:disabled]/checkbox:text-t-border"
                                              for="Filter-filter.p.${this.handleize(d.display_name)}-${e}-${o}"
                                            >
                                              ${d.display_name}
                                            </label>
                                          </div>
                                        </li>`:h}`)}
                              </ul>
                              ${i.options.length>this.facetsCheckboxVisibleLimit?n`
                                    <toggle-button
                                      role="button"
                                      data-toggled="false"
                                      class="group/toggle-button ${window.brand=="NG"?"text-t-foreground-secondary font-bold":"text-t-foreground"} text-utility-bold mt-md underline md:mt-xs"
                                    >
                                      <span
                                        class='group-data-[toggled="true"]/toggle-button:hidden'
                                        >${this.textViewAllCount.replace("{{ count }}",`${i.options.length}`)}</span
                                      >
                                      <span
                                        class='group-data-[toggled="false"]/toggle-button:hidden'
                                        >${this.textHideCount.replace("{{ count }}",`${i.options.length-this.facetsCheckboxVisibleLimit}`)}</span
                                      >
                                    </toggle-button>
                                  `:h}
                            </div>
                          `:h}
                    `}
                  </details>`:h}`})}
        </div>
        ${e=="Mobile"?n`
              <div
                class="group/toggle-clear-all flex w-full flex-col items-center justify-center gap-xs border-t border-t-border bg-t-background px-pagegridmargin py-sm"
                data-show-clear-all=${(s??0)>0}
              >
                <dialog-toggle modal-id="${l}" class="w-full">
                  <button class="btn w-full" variant="primary">
                    ${((r=this.textApply)==null?void 0:r.replace("{{ count }}",(s==null?void 0:s.toString())??""))??""}
                  </button>
                </dialog-toggle>
                <button
                  class='text-utility-bold block cursor-pointer text-t-foreground underline group-data-[show-clear-all="false"]/toggle-clear-all:hidden'
                  target-clear-all-filters
                  @click=${this.clearAllFilters}
                >
                  ${this.textClearAll}
                </button>
              </div>
            `:h}
      </div>
    `}getSortHTML(t,e){return n`
      ${e=="Desktop"?n` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="max-md:hidden"
          >
            <form
              id="SortOptionsForm${e}"
              class="gap-2xs${window.brand=="TFC"?" !font-normal":""} text-utility-bold flex"
            >
              <label for="SortBy">${this.textSort}:</label>
              <div class="relative">
                <select
                  name="sort_by"
                  id="SortBy"
                  aria-describedby="a11y-refresh-page-message"
                  class="outline-none${window.brand=="TFC"?" bg-transparent":""} block w-full appearance-none pr-sm"
                  @change=${this.handleSelectChange}
                >
                  ${y(t??[],l=>l.sort_by+e,l=>{var s;return n`
                      <option
                        value="${l.sort_by}"
                        ${l.status!=""?' selected="selected"':""}
                      >
                        ${(s=l.display_name)==null?void 0:s.replace("Most Relevant","Featured")}
                      </option>
                    `})}
                </select>
                <svg-icon
                  src="icon-select-arrow"
                  class="pointer-events-none absolute right-0 top-2/4 -translate-y-2/4"
                  style="--icon-size: 16px;"
                ></svg-icon>
              </div>
            </form>
          </facet-filters-form>`:n` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="flex h-full"
          >
            <form
              id="SortOptionsForm${e}"
              class="flex w-full flex-col"
            >
              <div
                id="SortOptionsForm${e}_sort"
                class="group/facet max-md:px-pagegridmargin max-md:py-md md:pb-sm"
                sub-section-id="SortOptionsForm${e}_sort"
                data-sort-by="title-ascending"
              >
                <ul class="list-unstyled space-y-xs md:space-y-2xs" role="list">
                  ${y(t??[],l=>l.sort_by+e,l=>n`
                      <li class="py-2xs" data-selected="false">
                        <div
                          class="group/radio inline-flex items-start justify-start gap-x-xs"
                        >
                          <div
                            class="peer relative flex cursor-pointer items-center rounded-full"
                          >
                            <input
                              type="radio"
                              class="peer relative size-4 cursor-pointer appearance-none rounded-full border border-t-foreground-secondary text-t-foreground-secondary transition-all checked:border-t-foreground-secondary disabled:border-t-border"
                              id="sortoptionsform${e}_input_${l.sort_by}"
                              name="sort_by"
                              value="${l.sort_by}"
                              @change=${this.handleSelectChange}
                              .checked=${l.status!=""}
                            />
                            <span
                              class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 scale-0 text-t-foreground opacity-0 transition-[opacity,transform-] peer-checked:scale-100 peer-checked:opacity-100"
                            >
                              <svg-icon
                                src="icon-radio-circle"
                                class="block"
                                style="--icon-size: 10px;"
                              ></svg-icon>
                            </span>
                          </div>
                          <label
                            class="mt-px cursor-pointer select-none"
                            for="sortoptionsform${e}_input_new-arrivals8"
                          >
                            <div>
                              <p
                                id="sortoptionsform${e}_input_new-arrivals8_label"
                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/radio:text-t-disabled"
                              >
                                ${l.display_name.replace("Most Relevant","Featured")}
                              </p>
                            </div>
                          </label>
                        </div>
                      </li>
                    `)}
                </ul>
              </div>
            </form>
          </facet-filters-form>`}
    `}getPaginationArray(t,e){const s=[];if(s.push("1"),e<=6)for(let r=2;r<e;r++)s.push(r);else if(t<=3){for(let r=2;r<=4;r++)s.push(r);s.push("...")}else if(t>=e-2){s.push("...");for(let r=e-3;r<e;r++)s.push(r)}else s.push("..."),s.push(t-1),s.push(t),s.push(t+1),s.push("...");return s[s.length-1]!==e&&s.push(e),s.map(r=>r.toString())}getPaginateHTML(t,e=1){if(!t)return;const l=this.getPaginationArray(e,t.length);if(l)return n`
      ${(t==null?void 0:t.length)>1?n`
            <div class="flex justify-center px-lg pb-lg pt-md">
              <ul
                class="flex list-none items-center justify-center gap-2.5"
                role="list"
              >
                ${(t==null?void 0:t.length)>1?n`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===1?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="-1"
                          ?disabled=${e===1}
                          aria-disabled="${e===1}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: 90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:h}
                ${y(l,s=>"productPage"+s,s=>n`
                    ${s!="..."?n`
                          <li class="inline-flex list-none">
                            <button
                              class="${s==e.toString()?`${window.brand=="NG"?"border-t-foreground-secondary bg-t-accent-04":"border-t-foreground"}`:"border-t-border"} ${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border"
                              aria-current="${s==e.toString()?"page":h}"
                              @click=${this.paginateHandleClick}
                            >
                              <span class="utility-standard pointer-events-none"
                                >${s}</span
                              >
                            </button>
                          </li>
                        `:n`
                          <li class="inline-flex list-none">
                            <span
                              class="${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border border-t-border"
                            >
                              <span class="utility-standard pointer-events-none"
                                >…</span
                              >
                            </span>
                          </li>
                        `}
                  `)}
                ${(t==null?void 0:t.length)>1?n`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===t.length?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="1"
                          ?disabled=${e===t.length}
                          aria-disabled="${e===t.length}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: -90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:h}
              </ul>
            </div>
          `:h}
    `}removeFacet(t){const e=t.target;if(e.dataset.name=="price")this.currentPage=1,this.filterChanged(e.closest("collection-results-section"),e);else{const l=this.querySelector(`[target-filters][is-mobile] [name="${e.dataset.name}"][value="${e.dataset.value}"]`);l&&l.click()}}getFacetRemove(t,e){return n`
      <facet-remove
        class="flex cursor-pointer snap-center items-center gap-2xs whitespace-nowrap rounded-sm bg-t-background-secondary px-xs py-[0.438rem]"
        data-name="${t.name}"
        data-value="${t.display_name}"
        @click=${this.removeFacet}
      >
        <svg-icon
          src="icon-close"
          class="pointer-events-none block"
          style="--icon-size: 8px"
        ></svg-icon>
        <span
          class="text-utility-regular pointer-events-none text-t-foreground"
        >
          ${t.type=="range"?n`$${t.min} - $${t.max}`:t.name=="rating_tier"?n`
                  <div class="flex items-center gap-1">
                    ${y([1,2,3,4,5],l=>"star"+l+e,l=>l<=parseFloat(t.display_name)?n`<svg-icon
                              src="icon-star-full"
                              class="block text-t-accent-01"
                              style="--icon-size: 16px;"
                            ></svg-icon>`:n`<svg-icon
                              src="icon-star-empty"
                              class="block text-t-foreground-secondary"
                              style="--icon-size: 16px;"
                            ></svg-icon>`)}
                  </div>
                `:n`${t.display_name}`}
        </span>
      </facet-remove>
    `}getFilteredFacets(t,e){if(!(t!=null&&t.length))return n``;const l=(t==null?void 0:t.reduce((s,r)=>{if(r.type!=="range"){const i=r.options.filter(a=>a.status==="selected").map(a=>({...a,name:r.name}));return s.concat(i)}else{const i=Object.hasOwn(r.status,"min")&&Object.hasOwn(r.status,"max"),a=r.status.min!==r.min,d=r.status.max<(this._productsMaxPrice??r.max);return i&&(a||d)&&s.push({...r,min:r.status.min,max:r.status.max}),s}},[]))??[];return n`
      <div
        class="empty:pt-0${e=="Desktop"?" max-md:hidden":""} col-span-full w-full pt-sm empty:hidden"
        data-target-facet-removes="${e==null?void 0:e.toLowerCase()}"
      >
        ${l.length>0?n` <facet-filters-form
              section-id="facet-filters"
              class="[&amp;[loading]]:opacity-50 [&amp;[loading]]:pointer-events-none flex h-full w-full"
              data-mode="facet-removes"
              data-form-id="FacetRemovesForm${e}"
              data-filters-form-id="FacetFiltersForm${e}"
            >
              <form
                id="FacetRemovesForm${e}"
                class="${e=="Desktop"?"flex-wrap":"no-scrollbar overflow-x-auto snap-x snap-mandatory px-xs"} flex w-full items-center gap-2xs"
              >
                ${y(l??[],s=>s.name,s=>this.getFacetRemove(s,e))}
                ${e=="Desktop"?n`<facet-remove
                      class="text-utility-bold ml-2xs cursor-pointer text-t-foreground underline"
                      target-clear-all-filters
                      @click=${this.clearAllFilters}
                    >
                      ${this.textClearAll}
                    </facet-remove>`:h}
              </form>
            </facet-filters-form>`:h}
      </div>
    `}getModalDialog(t,e,l,s,r,i,a,d,o){return n`
      <modal-dialog
        cloak
        type="${r}"
        id="${t}"
        anchor="${e}"
        close-on-backdrop-click="true"
        drawer-classes="${o}"
        close-icon-size="${a}"
      >
        <h5 slot="header" class="${d} h6">${i}</h5>
        <div slot="additional-content">${s}</div>
        <form target-filters is-mobile class="h-full">${l}</form>
      </modal-dialog>
    `}render(){var t,e,l,s,r,i,a,d,o,u;return n` <search-results-section
      class="grid grid-cols-1 pb-sm 2xl:container md:grid-cols-[minmax(0,295px)_minmax(0,1fr)] md:gap-x-lg md:gap-y-xs md:px-pagemargin"
      data-pagination-results-per-page="${this.resultsPerPage}"
      target-content-results
      data-cnstrc-browse
      data-cnstrc-filter-name="type"
      data-cnstrc-filter-value="${this.type}"
      data-cnstrc-num-results="${((t=this.resourcesData)==null?void 0:t.totalResults)??0}"
    >
      ${this.getFilteredFacets(this.resourcesData.facets,"Desktop")}
      <aside class="md:block md:pb-6">
        <div class="max-md:hidden">
          <form target-filters>
            ${this.getFacetsHTML((e=this.resourcesData)==null?void 0:e.facets,"Desktop")}
          </form>
        </div>

        ${this.getModalDialog("filter-drawer-dialog-content","left",this.getFacetsHTML((l=this.resourcesData)==null?void 0:l.facets,"Mobile","filter-drawer-dialog-content"),this.getFilteredFacets(this.resourcesData.facets,"Mobile"),"drawer",this.textFilter,13,"!h4","!max-w-[22.5rem] !overflow-clip !text-t-foreground")}
        ${this.getModalDialog("sort-options-drawer-dialog-content","left",this.getSortHTML((s=this.resourcesData)==null?void 0:s.sortOptions,"Mobile"),n``,"drawer",this.textSort,13,"!h4","!max-w-[22.5rem]")}
      </aside>

      <div class="flex-grow" content-category-results="resources">
        <div>
          <div>
            <div
              id="content-grid-header-search"
              class="product-grid-header mb-sm flex flex-col md:mt-sm md:flex-row md:items-center md:justify-between md:gap-sm"
            >
              <div class="flex">
                <dialog-toggle
                  modal-id="filter-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-filters"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textFilter}</span
                    >
                  </button>
                </dialog-toggle>
                <dialog-toggle
                  modal-id="sort-options-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border-y border-r border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-sorting"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textSort}</span
                    >
                  </button>
                </dialog-toggle>
                ${this.getSortHTML((r=this.resourcesData)==null?void 0:r.sortOptions,"Desktop")}
              </div>
              <span
                class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} text-utility-regular max-md:mb-2xs max-md:mt-sm max-md:w-full max-md:px-pagegridmargin md:order-[-1]"
                >${(i=this.resourcesData)!=null&&i.totalResults?(((a=this.resourcesData)==null?void 0:a.totalResults)==1?this.dataResultsGridWithCountOne:this.dataResultsGridWithCountOther).replace("{{ count }}",`${(o=(d=this.resourcesData)==null?void 0:d.totalResults)==null?void 0:o.toLocaleString("en-US")}`):h}</span
              >
            </div>
            <div>
              <div
                class="grid gap-y-xs max-md:px-pagegridmargin md:grid-cols-2 md:gap-x-xs md:gap-y-md lg:grid-cols-4 lg:gap-y-7"
              >
                ${y(((u=this.resourcesData)==null?void 0:u.cards)??[],f=>f.id,f=>n`
                    <dynamic-card
                      handle="${f.handle}"
                      class="group/dynamic-card"
                      view="article-card"
                      query-type="article"
                      article-type="${this.type}"
                    >
                      <div
                        data-slot="article-card-skeleton"
                        class="relative grid w-full items-center gap-xs group-has-[a]/dynamic-card:hidden"
                      >
                        <div
                          data-slot="article-card-skeleton-image"
                          class="${window.brand=="NG"?"rounded-sm":""} block aspect-square animate-pulseskeleton overflow-clip bg-t-border"
                        ></div>
                        <div class="flex flex-col gap-2xs">
                          <div
                            data-slot="article-card-skeleton-caption"
                            class="${window.brand=="NG"?"rounded-sm":""} caption h-[1em] max-w-10 animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-title"
                            class="${window.brand=="NG"?"rounded-sm":""} text-heading-6 h-[1em] max-w-[90%] animate-pulseskeleton bg-t-border font-medium leading-[1.2]"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-exerpt"
                            class="${window.brand=="NG"?"rounded-sm":""} text-caption h-[1em] max-w-[80%] animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-exerpt"
                            class="${window.brand=="NG"?"rounded-sm":""} text-caption h-[1em] max-w-[50%] animate-pulseskeleton bg-t-border"
                          ></div>
                        </div>
                      </div>
                    </dynamic-card>
                  `)}
              </div>
            </div>
            ${this.getPaginateHTML(this.resourcesData.paginationIds,this.currentPage)}
          </div>
        </div>
      </div>
    </search-results-section>`}};g([b({type:String,attribute:"data-sort"})],m.prototype,"textSort",2);g([b({type:String,attribute:"data-filter"})],m.prototype,"textFilter",2);g([b({type:String,attribute:"data-hide-count"})],m.prototype,"textHideCount",2);g([b({type:String,attribute:"data-view-all-count"})],m.prototype,"textViewAllCount",2);g([b({type:String,attribute:"data-apply"})],m.prototype,"textApply",2);g([b({type:String,attribute:"data-clear-all"})],m.prototype,"textClearAll",2);g([b({type:String,attribute:"data-results-grid-with-count-one"})],m.prototype,"dataResultsGridWithCountOne",2);g([b({type:String,attribute:"data-results-grid-with-count-other"})],m.prototype,"dataResultsGridWithCountOther",2);g([b({type:String})],m.prototype,"type",2);g([b({type:Number})],m.prototype,"facetsCheckboxVisibleLimit",2);g([b({type:Number})],m.prototype,"currentPage",2);g([b({type:Number,attribute:"results-per-page"})],m.prototype,"resultsPerPage",2);g([b({type:Object})],m.prototype,"resourcesData",2);m=g([j("resource-results")],m);
